import { render, staticRenderFns } from "./DescriptionTab.vue?vue&type=template&id=f9f38960&"
import script from "./DescriptionTab.vue?vue&type=script&lang=js&"
export * from "./DescriptionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports